const  IconClose= () => {

    return (

        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <line x1="10.6464" y1="10.3536" x2="0.746952" y2="0.454059" stroke="white"/>
            <line x1="0.646447" y1="10.6465" x2="10.5459" y2="0.746956" stroke="white"/>
        </svg>
    )

}

export default IconClose;
